module.exports = __webpack_public_path__ + "7703ba62d32f4b15649fae871be161c1.jpg";


//////////////////
// WEBPACK FOOTER
// ../assets/img/authors/nick.jpg
// module id = 484
// module chunks = 0